$ = require 'jquery'

module.exports =
class contactSequence

  constructor: ->
    @$section       = $ '.section-contact'
    @$heading       = @$section.find '.heading-container .heading'
    @$ways          = @$section.find '.ways'
    @$waysIcon      = @$ways.find '.icon'
    @$waysLink      = @$ways.find '.link-inner'
    @$companyDetail = @$section.find '.company-detail'
    @$maps          = @$section.find '.maps'

  getInitialVals: =>
    [
      {
        e: [ @$heading ]
        p: { display: 'none' }
      }
      {
        e: [ @$companyDetail, @$maps, @$waysIcon, @$waysLink ]
        p: { visibility: 'hidden' }
      }
    ]

  getSequences: =>
    {
      first: [
        {
          e: @$heading
          p:
            opacity   : [ 1, 0 ]
            translateX: [ 0, 'easeOutSine', -200 ]
          o: { duration: 300, display: 'block' }
        }
        {
          e: @$companyDetail
          p:
            opacity   : [ 1, 0 ]
            translateX: [ 0, 'easeOutSine', 300 ]
          o: { duration: 300, visibility: 'visible' }
        }
        {
          e: @$maps
          p: { opacity: [ 1, 0 ] }
          o: { duration: 300, visibility: 'visible', delay: 200, sequenceQueue: false }
        }
        {
          e: @$waysIcon
          p: { scale: [ 1, 0 ] }
          o: { duration: 300, easing: 'easeOutSine', visibility: 'visible' }
        }
        {
          e: @$waysIcon
          p: { translateY: -10 }
          o: { duration: 100, easing: 'easeOutSine' }
        }
        {
          e: @$waysIcon
          p: { translateY: 0 }
          o: { duration: 100, easing: 'easeOutSine' }
        }
        {
          e: @$waysLink
          p: { width: [ '100%', 0 ] }
          o: { duration: 200, easing: 'easeOutSine', visibility: 'visible' }
        }
      ]
    }



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/anime-sequence/contact-sequence.coffee